import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const Database = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <ellipse
      cx="12.9961"
      cy="7"
      rx="7"
      ry="3"
      stroke="currentColor"
      strokeWidth="2"
      fill={'none'}
    />
    <path
      d="M5.99609 13C5.99609 13 5.99609 15.3431 5.99609 17C5.99609 18.6569 9.1301 20 12.9961 20C16.8621 20 19.9961 18.6569 19.9961 17C19.9961 16.173 19.9961 13 19.9961 13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      fill={'none'}
    />
    <path
      d="M5.99609 7C5.99609 7 5.99609 10.3431 5.99609 12C5.99609 13.6569 9.1301 15 12.9961 15C16.8621 15 19.9961 13.6569 19.9961 12C19.9961 11.173 19.9961 7 19.9961 7"
      stroke="currentColor"
      strokeWidth="2"
      fill={'none'}
    />
  </SvgIcon>
);

export default Database;
